;
define("header.tpl", function(){});

